export default function Hero() {
  const scrollToHours = () => {
    const element = document.getElementById('hours');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openBooking = () => {
    window.open('https://book.squareup.com/appointments/yc3ukarfxsbty9/location/LHRN4K68W4NE0', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-end pb-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://static.readdy.ai/image/559167c3f2f3505c4b7c1eaccde744d9/0129e1c62ccbb205b676b8ef03384f67.png" 
          alt="Reborn Barbershop interior - premium barber shop in Heidelberg Heights"
          className="w-full h-full object-cover object-center"
          style={{ filter: 'brightness(0.85) saturate(0.8)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/35"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-red-900/10 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-32 md:pt-36">
        <div className="max-w-3xl">
          {/* Location Badge */}
          <div className="inline-block mb-6 px-4 py-2 border border-red-600/50 rounded-full backdrop-blur-sm bg-black/20">
            <span className="text-red-400 text-xs tracking-widest font-semibold whitespace-nowrap">HEIDELBERG HEIGHTS PREMIUM BARBERS</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-7xl md:text-8xl font-bold text-white mb-6 leading-tight">
            Premium Cuts.<br />
            Sharp Style.<br />
            Real Confidence.
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-gray-300 mb-8 leading-relaxed max-w-2xl">
            Professional barbers delivering precision fades, modern haircuts, and expert beard grooming in Heidelberg Heights.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-6">
            <button 
              onClick={openBooking}
              className="bg-red-600 text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-red-700 transition-all hover:shadow-xl hover:shadow-red-600/50 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              BOOK YOUR APPOINTMENT
              <i className="ri-arrow-right-line"></i>
            </button>
            <button 
              onClick={scrollToHours}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-white hover:text-black transition-all whitespace-nowrap cursor-pointer"
            >
              WALK IN TODAY
            </button>
          </div>

          {/* Info Text */}
          <p className="text-gray-400 text-sm italic mb-4">
            Walk-ins are always welcome, or book your appointment online to secure your time with one of our professional barbers.
          </p>

          {/* Phone Number */}
          <a href="tel:0451279664" className="inline-flex items-center gap-3 text-white text-3xl font-bold hover:text-red-600 transition-colors">
            <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
              <i className="ri-phone-fill text-xl"></i>
            </div>
            0451 279 664
          </a>
        </div>
      </div>
    </section>
  );
}